import api, { Pagination } from '..'

export class CreditLineProvisionService {
  static async findAll(
    productId: string,
    pagination: Pagination,
    organizationId?: string,
    populate: string[] = ['creditLine']
  ) {
    const params: Record<string, string | number> = {
      sort: '-createdAt',
      productId,
      populate: populate.join(','),
      page: pagination.page,
      perPage: pagination.perPage
    }

    if (organizationId) {
      params.organizationId = organizationId
    }

    const response = await api.get('/credit-line-provisions', { params })
    return response.data
  }
}
